import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import './SearchSpace.css';

import MHDRequests from 'services/MHDRequests';
import consentRequests from 'services/consentRequests';
import { LoadingHU } from 'components/LoadingHU';
import { oids } from 'configs';
import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import { BrInput } from '@govbr-ds/react-components';
import { logDebug } from 'utils/AuxiliarFunctions';
import { toast } from 'react-toastify';
import { ToastMessage } from 'components';
import { isEmpty } from 'lodash';
import { FindPatient } from '../Results';
import { Warning } from '../Warning';

export function SimpleSearch({ type }) {
  const [loading, setLoading] = useState(false);
  const data = false;
  const [patientId, setPatientId] = useState('');
  const [patientData, setPatientData] = useState({});
  const [isOpen, setIsOpen] = useState(true);
  const { organizationList } = useNewConsentModalContext();
  const [noSearch, setNoSearch] = useState(true);

  async function handleSearchPatient(identifier) {
    setLoading(true);
    try {
      let organizationNames = [];
      const patientJson = await MHDRequests.getPatientJson({
        patientId: identifier,
      });
      if (patientJson === 'not_found')
        throw new Error('Paciente não encontrado');
      const name = patientJson.name[0].text;
      const { birthDate } = patientJson;
      const { gender } = patientJson;
      const patientIdentifier =
        patientJson.identifier.find(
          (element) =>
            element.system.includes(oids.cpf) ||
            element.system.includes(oids.cns),
        )?.value || 'Não Encontrado';
      const cnes = await consentRequests.getPatientCNES(patientIdentifier);

      if (cnes !== 'network_error') {
        organizationNames = cnes.map((cnesElement) => {
          let nameFound = '';
          try {
            nameFound = organizationList?.find((orgElement) =>
              orgElement.resource.id.includes(cnesElement),
            ).resource.alias[0];
          } catch (err) {
            logDebug(err);
          }
          return nameFound;
        });
      }
      toast.success(<ToastMessage type="success" />);
      setPatientData({
        name,
        birthDate,
        gender,
        patientIdentifier,
        cnes,
        organizationNames,
      });
    } catch (err) {
      toast.error(
        <ToastMessage type="error">
          Não foi possível buscar o paciente.
        </ToastMessage>,
      );
      setPatientData({});
    } finally {
      setLoading(false);
      setNoSearch(false);
    }
  }

  return (
    <div className="simpleSearch">
      <div className="flex">
        <p> Filtros </p>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="br-button circle small"
          type="button"
        >
          {isOpen ? (
            <i className="fas fa-angle-up" aria-hidden="true" />
          ) : (
            <i className="fas fa-angle-down" aria-hidden="true" />
          )}
        </button>
      </div>
      {isOpen && (
        <>
          <div className="search">
            <form
              onSubmit={(event) => {
                event.preventDefault();
                handleSearchPatient(patientId);
              }}
            >
              <div className="row">
                <div className="col">
                  <BrInput
                    style={{
                      border: '1px solid',
                      borderColor: 'var(--secondary-background-color)',
                    }}
                    value={patientId}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      const numericRegex = /^[0-9]*$/;

                      if (
                        numericRegex.test(newValue) &&
                        e.target.value?.length < 16
                      )
                        setPatientId(newValue);
                    }}
                    placeholder="CPF ou CNS do paciente"
                    label="CPF ou CNS"
                    type="datetime"
                  />
                </div>
              </div>

              <div className="row ajust-margin">
                <div className="col">
                  <div className="br-checkbox d-inline">
                    <input
                      id="busca"
                      name="busca"
                      onChange={() => type(data)}
                      type="checkbox"
                      aria-label="opção 1"
                    />
                    <label htmlFor="busca">Busca Avançada</label>
                  </div>
                </div>
                <div className="col-auto">
                  <button
                    className="simpleSearchButton br-button primary mt-3 mt-sm-0 ml-sm-3 "
                    type="submit"
                  >
                    Filtrar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      )}

      <LoadingHU state={loading} />
      {!isEmpty(patientData) ? (
        <FindPatient
          organization={
            patientData.cnes !== 'network_error'
              ? patientData.cnes?.map((cnesElement, index) => ({
                  name: patientData.organizationNames[index],
                  cnes: cnesElement,
                }))
              : []
          }
          patient={patientData}
        />
      ) : (
        isEmpty(patientData) && !noSearch && <Warning />
      )}
    </div>
  );
}
SimpleSearch.propTypes = {
  type: PropTypes.bool.isRequired,
};
